export default __webpack_public_path__ + "static/media/template-4.9bed5e34.png";